import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=15960c24&scoped=true"
import script from "./Case.vue?vue&type=script&lang=js"
export * from "./Case.vue?vue&type=script&lang=js"
import style0 from "./Case.vue?vue&type=style&index=0&id=15960c24&prod&scoped=true&lang=css"
import style1 from "./Case.vue?vue&type=style&index=1&id=15960c24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15960c24",
  null
  
)

export default component.exports